import React from 'react';
import { ModalController } from '../../../../components/Modal/ControlledModal';
import { Order, updateOrder } from '../../../../model/order';
import { useChanges, Form } from '../../../../components/Form/Form';
import { TagsInput } from '../../../../components/Form/TagsInput/TagsInput';
import { handleError } from '../../../../model/notification';

interface Props {
  order: Order;
  controller: ModalController<Partial<Order>>;
}

export function UpdateOrderTag({ order, controller }: Props): JSX.Element {
  const [changes, , tags, trackChanges] = useChanges<Partial<Order>>({
    tags: order.tags,
  });

  async function handleOnSubmit(): Promise<void> {
    try {
      await updateOrder({ orderId: order.id, tags: changes.tags });
      controller.close();
    } catch (error) {
      handleError(error);
    }
  }

  return (
    <Form model={tags} onInput={trackChanges}>
      {(form) => {
        controller.configure({
          onSubmit: handleOnSubmit,
          canSubmit: form.valid,
        });
        return (
          <>
            <TagsInput label="Tags" name="tags" required />
          </>
        );
      }}
    </Form>
  );
}
